import _styled from "@emotion/styled-base";
import React from 'react';

var TOCWrapper = _styled("div", {
  target: "eghs4qo0",
  label: "TOCWrapper"
})("margin-right:2em;border:1px solid ", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.borderMedium;
}, ";list-style-type:none;padding:1em;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.MQ.M;
}, "{float:left;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.MQ.L;
}, "{margin-left:", function (_ref4) {
  var theme = _ref4.theme;
  return "".concat((theme.BREAKPOINTS['M'] - theme.BREAKPOINTS['L']) / 2);
}, "px;}h4{margin-top:0;margin-bottom:0.5em;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9TaW1wbGVUT0MvaW5kZXguanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUc2QiIsImZpbGUiOiIuLi8uLi9zcmMvU2ltcGxlVE9DL2luZGV4LmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5jb25zdCBUT0NXcmFwcGVyID0gc3R5bGVkLmRpdmBcblx0bWFyZ2luLXJpZ2h0OiAyZW07XG5cdGJvcmRlcjogMXB4IHNvbGlkICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29sb3JzLmJvcmRlck1lZGl1bX07XG5cdGxpc3Qtc3R5bGUtdHlwZTogbm9uZTtcblx0cGFkZGluZzogMWVtO1xuXG5cdCR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuTVEuTX0ge1xuXHRcdGZsb2F0OiBsZWZ0O1xuXHR9XG5cblx0JHsoeyB0aGVtZSB9KSA9PiB0aGVtZS5NUS5MfSB7XG5cdFx0bWFyZ2luLWxlZnQ6ICR7KHsgdGhlbWUgfSkgPT4gYCR7KHRoZW1lLkJSRUFLUE9JTlRTWydNJ10gLSB0aGVtZS5CUkVBS1BPSU5UU1snTCddKSAvIDJ9YH1weDtcblx0fVxuXG5cdGg0IHtcblx0XHRtYXJnaW4tdG9wOiAwO1xuXHRcdG1hcmdpbi1ib3R0b206IDAuNWVtO1xuXHR9XG5gXG5cbmV4cG9ydCBjb25zdCBTaW1wbGVUT0MgPSAoeyBjb250ZW50TGlzdCB9KSA9PiB7XG5cdHJldHVybiAoXG5cdFx0PFRPQ1dyYXBwZXI+XG5cdFx0XHQ8aDQ+VGFibGUgb2YgQ29udGVudHM8L2g0PlxuXHRcdFx0PGxpPlxuXHRcdFx0XHR7Y29udGVudExpc3QubWFwKCh7IG5hbWUsIHNsdWcgfSwgaSkgPT4gKFxuXHRcdFx0XHRcdDxsaSBrZXk9e2Ake2l9LSR7c2x1Z31gfT5cblx0XHRcdFx0XHRcdDxhIGhyZWY9e2Ake3NsdWd9YH0+e25hbWV9PC9hPlxuXHRcdFx0XHRcdDwvbGk+XG5cdFx0XHRcdCkpfVxuXHRcdFx0PC9saT5cblx0XHQ8L1RPQ1dyYXBwZXI+XG5cdClcbn1cblxuU2ltcGxlVE9DLmRlZmF1bHRQcm9wcyA9IHtcblx0Y29udGVudExpc3Q6IFtcblx0XHR7IG5hbWU6ICdJbmZvcm1hdGlvbiBXZSBDb2xsZWN0Jywgc2x1ZzogJyNpbmZvcm1hdGlvbi13ZS1jb2xsZWN0JyB9LFxuXHRcdHsgbmFtZTogJ0hvdyBXZSBVc2UgWW91ciBJbmZvcm1hdGlvbicsIHNsdWc6ICcjaG93LXdlLXVzZS15b3VyLWluZm8nIH0sXG5cdFx0eyBuYW1lOiAnV2hlbiBXZSBEaXNjbG9zZSBZb3VyIEluZm9ybWF0aW9uJywgc2x1ZzogJyN3aGVuLXdlLWRpc2Nsb3NlLXlvdXItaW5mb3JtYXRpb24nIH0sXG5cdFx0eyBuYW1lOiAnTGVnYWwgQmFzaXMgZm9yIFByb2Nlc3NpbmcgUGVyc29uYWwgRGF0YScsIHNsdWc6ICcjbGVnYWwtYmFzaXMtZm9yLXByb2Nlc3NpbmctcGVyc29uYWwtZGF0YScgfSxcblx0XHR7IG5hbWU6ICdQZXJzb25hbGl6ZWQgQ29uc2VudCBhbmQgQWR2ZXJ0aXNpbmcnLCBzbHVnOiAnI3BlcnNvbmFsaXplZC1jb25zZW50LWFkdmVydGlzaW5nJyB9LFxuXHRcdHsgbmFtZTogJ1lvdXIgUmlnaHRzIGFuZCBDaG9pY2VzJywgc2x1ZzogJyN5b3VyLXJpZ2h0cy1hbmQtY2hvaWNlcycgfSxcblx0XHR7IG5hbWU6ICdTZWN1cml0eScsIHNsdWc6ICcjc2VjdXJpdHknIH0sXG5cdFx0eyBuYW1lOiAnRGF0YSBSZXRlbnRpb24nLCBzbHVnOiAnI2RhdGEtcmV0ZW50aW9uJyB9LFxuXHRcdHsgbmFtZTogJ0ludGVybmF0aW9uYWwgVXNlcnMnLCBzbHVnOiAnI2ludGVybmF0aW9uYWwtdXNlcnMnIH0sXG5cdFx0eyBuYW1lOiAnVGhpcmQgUGFydHkgTGlua3MgYW5kIFNlcnZpY2VzJywgc2x1ZzogJyN0aGlyZC1wYXJ0eS1saW5rcy1hbmQtc2VydmljZXMnIH0sXG5cdFx0eyBuYW1lOiAnWW91ciBDYWxpZm9ybmlhIFByaXZhY3kgUmlnaHRzJywgc2x1ZzogJyN5b3VyLWNhbGlmb3JuaWEtcHJpdmFjeS1yaWdodHMnIH0sXG5cdFx0eyBuYW1lOiAnSW5mb3JtYXRpb24gZnJvbSBDaGlsZHJlbicsIHNsdWc6ICcjaW5mb3JtYXRpb24tZnJvbS1jaGlsZHJlbicgfSxcblx0XHR7IG5hbWU6ICdDaGFuZ2VzIHRvIHRoaXMgUG9saWN5Jywgc2x1ZzogJyNjaGFuZ2VzLXRvLXRoaXMtcG9saWN5JyB9LFxuXHRcdHsgbmFtZTogJ0NvbnRhY3QgVXMnLCBzbHVnOiAnI3F1ZXN0aW9ucy1hYm91dC10aGlzLXBvbGljeScgfSxcblx0XSxcbn1cbiJdfQ== */"));

export var SimpleTOC = function SimpleTOC(_ref5) {
  var contentList = _ref5.contentList;
  return /*#__PURE__*/React.createElement(TOCWrapper, null, /*#__PURE__*/React.createElement("h4", null, "Table of Contents"), /*#__PURE__*/React.createElement("li", null, contentList.map(function (_ref6, i) {
    var name = _ref6.name,
        slug = _ref6.slug;
    return /*#__PURE__*/React.createElement("li", {
      key: "".concat(i, "-").concat(slug)
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(slug)
    }, name));
  })));
};
SimpleTOC.defaultProps = {
  contentList: [{
    name: 'Information We Collect',
    slug: '#information-we-collect'
  }, {
    name: 'How We Use Your Information',
    slug: '#how-we-use-your-info'
  }, {
    name: 'When We Disclose Your Information',
    slug: '#when-we-disclose-your-information'
  }, {
    name: 'Legal Basis for Processing Personal Data',
    slug: '#legal-basis-for-processing-personal-data'
  }, {
    name: 'Personalized Consent and Advertising',
    slug: '#personalized-consent-advertising'
  }, {
    name: 'Your Rights and Choices',
    slug: '#your-rights-and-choices'
  }, {
    name: 'Security',
    slug: '#security'
  }, {
    name: 'Data Retention',
    slug: '#data-retention'
  }, {
    name: 'International Users',
    slug: '#international-users'
  }, {
    name: 'Third Party Links and Services',
    slug: '#third-party-links-and-services'
  }, {
    name: 'Your California Privacy Rights',
    slug: '#your-california-privacy-rights'
  }, {
    name: 'Information from Children',
    slug: '#information-from-children'
  }, {
    name: 'Changes to this Policy',
    slug: '#changes-to-this-policy'
  }, {
    name: 'Contact Us',
    slug: '#questions-about-this-policy'
  }]
};